import {
    GET_OCCUPANTS,
    GET_OCCUPANTS_SUCCESS,
    GET_OCCUPANTS_FAILURE,
    GET_OCCUPANT_DETAILS,
    GET_OCCUPANT_DETAILS_SUCCESS,
    GET_OCCUPANT_DETAILS_FAILURE,
    CREATE_OCCUPANT,
    CREATE_OCCUPANT_SUCCESS,
    CREATE_OCCUPANT_FAILURE,
    UPDATE_OCCUPANT,
    UPDATE_OCCUPANT_SUCCESS,
    UPDATE_OCCUPANT_FAILURE,
    DELETE_OCCUPANT,
    DELETE_OCCUPANT_SUCCESS,
    DELETE_OCCUPANT_FAILURE,
    UPLOAD_OCCUPANT_DOCUMENT,
    UPLOAD_OCCUPANT_DOCUMENT_SUCCESS,
    UPLOAD_OCCUPANT_DOCUMENT_FAILURE,
    DELETE_OCCUPANT_DOCUMENT,
    DELETE_OCCUPANT_DOCUMENT_SUCCESS,
    DELETE_OCCUPANT_DOCUMENT_FAILURE,
    LIST_OCCUPANT_DOCUMENTS,
    LIST_OCCUPANT_DOCUMENTS_SUCCESS,
    LIST_OCCUPANT_DOCUMENTS_FAILURE
} from '../../../actions/index.types';

const initialState = {
    // List
    occupantsData: [],
    occupantsPagination: null,
    loading: false,
    error: null,

    // Details
    occupantDetails: null,
    detailsLoading: false,
    detailsError: null,

    // Create
    createLoading: false,
    createError: null,
    createSuccess: false,

    // Update
    updateLoading: false,
    updateError: null,
    updateSuccess: false,

    // Delete
    deleteLoading: false,
    deleteError: null,
    deleteSuccess: false,

    // Documents (Police NOC, Rental Agreement, other)
    documents: [],
    documentsLoading: false,
    documentUploadLoading: false,
    documentDeleteLoading: false
};

const OccupantReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get All Occupants
        case GET_OCCUPANTS:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_OCCUPANTS_SUCCESS:
            return {
                ...state,
                loading: false,
                occupantsData: action.data?.data || [],
                occupantsPagination: action.data?.meta?.pagination || null,
                error: null
            };
        case GET_OCCUPANTS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.data
            };

        // Get Occupant Details
        case GET_OCCUPANT_DETAILS:
            return {
                ...state,
                detailsLoading: true,
                detailsError: null
            };
        case GET_OCCUPANT_DETAILS_SUCCESS:
            return {
                ...state,
                detailsLoading: false,
                occupantDetails: action.data,
                // Seed the documents list from the details payload so the FE
                // has something to render before LIST_OCCUPANT_DOCUMENTS runs.
                documents: Array.isArray(action.data?.documents) ? action.data.documents : state.documents,
                detailsError: null
            };
        case GET_OCCUPANT_DETAILS_FAILURE:
            return {
                ...state,
                detailsLoading: false,
                detailsError: action.data
            };

        // Create Occupant
        case CREATE_OCCUPANT:
            return {
                ...state,
                createLoading: true,
                createError: null,
                createSuccess: false
            };
        case CREATE_OCCUPANT_SUCCESS:
            return {
                ...state,
                createLoading: false,
                createSuccess: true,
                createError: null
            };
        case CREATE_OCCUPANT_FAILURE:
            return {
                ...state,
                createLoading: false,
                createError: action.data,
                createSuccess: false
            };

        // Update Occupant
        case UPDATE_OCCUPANT:
            return {
                ...state,
                updateLoading: true,
                updateError: null,
                updateSuccess: false
            };
        case UPDATE_OCCUPANT_SUCCESS:
            return {
                ...state,
                updateLoading: false,
                updateSuccess: true,
                updateError: null
            };
        case UPDATE_OCCUPANT_FAILURE:
            return {
                ...state,
                updateLoading: false,
                updateError: action.data,
                updateSuccess: false
            };

        // Delete Occupant
        case DELETE_OCCUPANT:
            return {
                ...state,
                deleteLoading: true,
                deleteError: null,
                deleteSuccess: false
            };
        case DELETE_OCCUPANT_SUCCESS:
            return {
                ...state,
                deleteLoading: false,
                deleteSuccess: true,
                deleteError: null
            };
        case DELETE_OCCUPANT_FAILURE:
            return {
                ...state,
                deleteLoading: false,
                deleteError: action.data,
                deleteSuccess: false
            };

        // ---------------- Occupant documents ----------------
        case LIST_OCCUPANT_DOCUMENTS:
            return { ...state, documentsLoading: true };
        case LIST_OCCUPANT_DOCUMENTS_SUCCESS:
            return {
                ...state,
                documentsLoading: false,
                documents: Array.isArray(action.data) ? action.data : []
            };
        case LIST_OCCUPANT_DOCUMENTS_FAILURE:
            return { ...state, documentsLoading: false };

        case UPLOAD_OCCUPANT_DOCUMENT:
            return { ...state, documentUploadLoading: true };
        case UPLOAD_OCCUPANT_DOCUMENT_SUCCESS:
            return {
                ...state,
                documentUploadLoading: false,
                // Prepend the newly-uploaded doc so it's visible immediately,
                // dropping the files it replaced (Police NOC / agreement hold
                // one file each - the API deactivates the old one).
                documents: action.data
                    ? [action.data, ...(state.documents || []).filter(d =>
                        !(action.data.replaced_document_ids || []).includes(d.document_id))]
                    : state.documents
            };
        case UPLOAD_OCCUPANT_DOCUMENT_FAILURE:
            return { ...state, documentUploadLoading: false };

        case DELETE_OCCUPANT_DOCUMENT:
            return { ...state, documentDeleteLoading: true };
        case DELETE_OCCUPANT_DOCUMENT_SUCCESS:
            return {
                ...state,
                documentDeleteLoading: false,
                documents: (state.documents || []).filter(
                    d => Number(d.document_id) !== Number(action.data?.document_id)
                )
            };
        case DELETE_OCCUPANT_DOCUMENT_FAILURE:
            return { ...state, documentDeleteLoading: false };

        default:
            return state;
    }
};

export default OccupantReducer;
